import React, { useEffect, useState } from "react";
import styles from "./otp.module.css";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { login, loginWithPhone, resendOtpForLogin, resendOtpForLoginWithEmail, resendOtpForSignUp, verifyLogin, verifyLoginWithPhone, verifyOtp } from "../../../redux/loginSlice";
import { unwrapResult } from "@reduxjs/toolkit";
import { Success } from "../success/Success";
import { setVisible } from "../../../redux/authModelSlice";


const Otp = ({ onClose }) => {
  const dispatch = useDispatch();

  const { isLoading, errorMsg,  } = useSelector((state) => state.login);

  const [otp, setOtp] = useState(["", "", "", "", "", ""]);
  const [countdown, setCountdown] = useState(600);
  const [isResendDisabled, setIsResendDisabled] = useState(true);
  const [otpLoading, setOtpLoading] = useState(false)

  const { visible, data, mode } = useSelector(state => state.model);



  useEffect(() => {
    if (visible === "otp") {
      setCountdown(600); // Reset countdown when OTP modal is opened
      setIsResendDisabled(true);
    }
  }, [visible]);
  
  useEffect(() => {
    if (countdown > 0) {
      const timer = setTimeout(() => {
        setCountdown(countdown - 1);
      }, 1000);
      return () => clearTimeout(timer);
    } else {
      setIsResendDisabled(false);
    }
  }, [countdown]);



  const handleInputChange = (e, index) => {
    const value = e.target.value;
    if (isNaN(value)) return;

    const newOtp = [...otp];
    newOtp[index] = value;
    setOtp(newOtp);

    if (value !== "" && index < otp.length - 1) {
      document.getElementById(`otp-input-${index + 1}`).focus();
    }
  };

  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace" && otp[index] === "" && index > 0) {
      document.getElementById(`otp-input-${index - 1}`).focus();
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setOtp(["", "", "", "", "", ""]); 
    try {
      const otpValue = otp.join("");
      if (otpValue.length === otp.length) {
        let resultAction;
        if (mode === "signup") {
          resultAction = await dispatch(
            verifyOtp({ otp: otpValue, phone: data.phone })
          );
        } else if (mode === "loginwithphone") {
          resultAction = await dispatch(
            verifyLoginWithPhone({ otp: otpValue, phone: data.phone })
          );
        } else if (mode === "loginwithmail") {
          resultAction = await dispatch(
            verifyLogin({ otp: otpValue, email: data.email })
          );
        }

        unwrapResult(resultAction);
        if (mode === "signup" && resultAction.payload === 200) {
          dispatch(setVisible("signin"));
        } else if (
          (mode === "loginwithphone" || mode === "loginwithmail") &&
          resultAction.payload === 200
        ) {
          dispatch(setVisible("success"));
        }

        // onClose()
      }
    } catch (err) { }
  };

  const handleResendOtp = async () => {
    const values = { phone: data?.phone };
    const val = {email: data?.email}
    setOtp(["", "", "", "", "", ""]);
    setIsResendDisabled(true); // Disable resend button
    setOtpLoading(true);
  
    let result;
    if (mode === "signup") {
      result = await dispatch(resendOtpForSignUp(values));
    } else if (mode === "loginwithphone") {
      result = await dispatch(resendOtpForLogin(values));
    } else if (mode === "loginwithmail"){
      result = await dispatch(resendOtpForLoginWithEmail(val))
    }
  
    unwrapResult(result);
    if (result.payload === 200) {
      setCountdown(120);
    }
  
    setOtpLoading(false);
  };
  

  const formatTime = (seconds) => {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;
    return `${minutes}:${remainingSeconds < 10 ? "0" : ""}${remainingSeconds}`;
  };

  if (visible !== 'otp') {
    return null
  }

  const handleBack = () => {

    if (mode === 'loginwithphone') {
      return dispatch(setVisible('signin'))
    }
    dispatch(setVisible('signup'))
  }

  return (
    <>
      <div className={styles.popupOverlay} >
        <div className={styles.login_container}>
          <div className={styles.image_section}>
            <img  src="/assets/loginImg.jpeg" alt="login" />
          </div>
          <div className={styles.form_section} >
            <div className={styles.arrowback} style={{ cursor: 'pointer' }} onClick={handleBack}>
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M15.5304 3.54975C15.8232 3.84264 15.8232 4.31752 15.5304 4.61041L9.01036 11.1304C8.53325 11.6075 8.53325 12.3926 9.01036 12.8697L15.5304 19.3897C15.8232 19.6826 15.8232 20.1575 15.5304 20.4504C15.2375 20.7433 14.7626 20.7433 14.4697 20.4504L7.9497 13.9304C6.8868 12.8675 6.8868 11.1326 7.9497 10.0697L14.4697 3.54975C14.7626 3.25685 15.2375 3.25685 15.5304 3.54975Z" fill="#131118" />
              </svg>
              <span >Back</span>
            </div>
            <button className={styles.closeButton} onClick={() => dispatch(setVisible(''))}>
              <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M23.6841 8.31641L8.31633 23.6842" stroke="#C4C4C4" stroke-width="2" stroke-linecap="round" />
                <path d="M23.6833 23.6855L8.3156 8.3178" stroke="#C4C4C4" stroke-width="2" stroke-linecap="round" />
              </svg>
            </button>
            <div >
            <img src="/pavithrajewelslogo.png" alt="logo" />
            </div>
            <h2>OTP Verification</h2>
            <p style={{ textAlign: 'center' }}>
              We have shared a code to your {mode === "loginwithmail" ? "email" : "phone number"} <br /> 
              <span style={{ textAlign: 'center' }}>+{data?.phone && `${data.phone.slice(0, 2)} ${data.phone.slice(2)}`}</span>
            </p>
            <div className={styles.form_container}>
              <div className={styles.number_boxes}>
                {otp.map((digit, index) => (
                  <input
                    key={index}
                    type="text"
                    className={styles.box}
                    id={`otp-input-${index}`}
                    maxLength="1"
                    value={digit}
                    onChange={(e) => handleInputChange(e, index)}
                    onKeyDown={(e) => handleKeyDown(e, index)}
                  />
                ))}
              </div>
              <button type="submit" onClick={handleSubmit} disabled={isLoading}>
                {isLoading ? "Verifying..." : "Verify"}
              </button>
              {errorMsg && <p className={styles.error}>{errorMsg}</p>}
              {/* {success && <p className={styles.success}>OTP Verified!</p>} */}

              <div className={styles.newuser}>
                {countdown > 0 ? (
                  <p>Resend OTP in <span> {formatTime(countdown)} </span></p>
                ) : (
                  <p>
                    Didn't receive OTP? &nbsp;
                    <span className={styles.signup}
                      //  onClick={handleResendOtp}
                      onClick={handleResendOtp}
                      style={{ cursor: 'pointer' }}
                      disabled={otpLoading}
                    >
                      {otpLoading ? 'please wait...' : "Resend"}
                    </span>
                  </p>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* {isLoginSuccessful && (
        <Success
          onClose={closeSuccessModal}
          modes={modes}
        />
      )} */}
    </>
  );
};

export default Otp;
